module.exports = __webpack_public_path__ + "img/water-drop-blue.8cf59a4f.svg";